import { useState } from "react";
import { KICK_REPORT_TEMPLATE_NAME } from "@common/constants/reports/report-settings-template";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { StandardModal, StandardModalHeader } from "@design-system/Modal/Modal";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { FullScreenExitIcon, FullScreenIcon } from "@icons";
import { ReportTemplatePreviewBody } from "./ReportTemplatePreviewBody";
import styles from "./ReportTemplatePreview.module.scss";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export const KickReportTemplatePreviewModal = ({ isOpen, onClose }: Props) => {
    const [isMaximized, setIsMaximized] = useState(false);
    const [openCount, setOpenCount] = useState(0);
    const fullScreenLabel = isMaximized ? "Exit full screen" : "Full screen";

    return (
        <StandardModal
            show={isOpen}
            onHide={onClose}
            onExited={() => {
                setIsMaximized(false);
                setOpenCount((count) => count + 1);
            }}
            fullscreen={isMaximized}
            dialogClassName={isMaximized ? undefined : styles.dialog}
            contentClassName={isMaximized ? undefined : styles.content}
        >
            <StandardModalHeader className={styles.header}>
                <HStack
                    justify="between"
                    align="center"
                    className={styles.headerRow}
                >
                    <span>Preview {KICK_REPORT_TEMPLATE_NAME} template</span>
                    <Tooltip content={fullScreenLabel}>
                        <Button
                            variant="secondary"
                            size="md"
                            iconOnly
                            aria-label={fullScreenLabel}
                            onClick={() => setIsMaximized(!isMaximized)}
                        >
                            {isMaximized ? (
                                <FullScreenExitIcon />
                            ) : (
                                <FullScreenIcon />
                            )}
                        </Button>
                    </Tooltip>
                </HStack>
            </StandardModalHeader>
            <ReportTemplatePreviewBody key={openCount} />
        </StandardModal>
    );
};
